import { React, useCallback, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

// components
import Loader from '../../components/loader';

// assets
import Logo from "../../assets/logo/GROSalon.png"

// constants
import { ROUTES } from '../../constants';

export default function Login(props) {
    const { onLogin } = props;

    const navigate = useNavigate()
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const login = useCallback(() => {
        setLoading(true);

        fetch(`${process.env.REACT_APP_GRO_BACKEND_URI}/clinic/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email.trim().toLowerCase(),
                password: password,
            }),
        })
            .then(response => response.json())
            .then(response => {
                if (response.success) {
                    localStorage.setItem('access_token', response.access_token);
                    localStorage.setItem('expires_at', response.expires_at);
                    localStorage.removeItem('staffId');
                    onLogin()
                    navigate(ROUTES.STAFF_SELECT)
                } else {
                    setError(response.message);
                    setLoading(false);
                }
            })
            .catch(error => {
                console.error(error);
                setError('An error occurred, please try again later');
                setLoading(false);
            });
    }, [email, navigate, onLogin, password]);

    return (
        <>
            {!loading && (
                <main className={`flex-grow flex flex-col p-4 font-font-2`}>
                    <>
                        <NavLink to="/" className="mx-auto mt-16">
                            <img className='h-20' src={Logo} alt="GRO Track" />
                        </NavLink>
                        <div className="flex flex-col items-center my-auto pb-32">
                            {error && <p className="text-center text-red-500 font-bold">{error}</p>}
                            <>
                                <form
                                    className="mt-4 flex flex-col w-full sm:w-3/5 md:w-1/2 lg:w-[400px] gap-6 items-center"
                                    onSubmit={event => {
                                        event.preventDefault();
                                        login();
                                    }}
                                >
                                    <input
                                        type="email"
                                        className="custom-input w-full px-6 py-3 bg-text-1 rounded-lg text-xl font-normal focus:outline-none text-[#3E6975]"
                                        placeholder="email"
                                        value={email}
                                        required
                                        onChange={event => {
                                            setEmail(event.target.value);
                                        }}
                                    />
                                    <input
                                        type="password"
                                        className="custom-input w-full px-6 py-3 bg-text-1 rounded-lg text-xl font-normal focus:outline-none text-[#3E6975]"
                                        placeholder="password"
                                        value={password}
                                        required
                                        minLength="8"
                                        onChange={event => {
                                            setPassword(event.target.value);
                                        }}
                                    />
                                    <input
                                        className="mt-5 w-full py-3 bg-[#f4831f] font-semibold rounded-[5px] text-white cursor-pointer capitalize focus:outline-none"
                                        type="submit"
                                        value={'Login'}
                                    />
                                </form>
                            </>
                        </div>
                    </>
                </main>
            )}
            {loading && (
                <Loader
                    message={'Logging you in, '}
                />
            )}
        </>
    );
}
